$(document).ready(function () {

    // Limit counter on message
    UpdateCountdown($('#txtMessage'), $('#countdown'), 300, strLabelCharactersLeft);

    $('#txtMessage').on('input', function () {
        UpdateCountdown($('#txtMessage'), $('#countdown'), 300, strLabelCharactersLeft);
    });

    // Changing amount (€)
    var objForm = $('form#frmAddToCart');
    objForm.find('select#selAmount').change(function () {
        // Change priceno for adding to cart after changing amount
        objForm.find('input#hdnPriceNo').val($(this).val());

        $('#card-price').html($(this).find('option:selected').text());

        // Change url for popup to add product to cart
        var strHrefProductAdded = $('select#selAmount').find(':selected').data('href');
        $('input[name=\'hdnHrefPopupProductAdded\']').val(strHrefProductAdded);
    });

    // Changing From
    objForm.find('input#txtName').change(function () {
        if ($(this).val()) {
            $('#card-from').html($(this).val()).addClass('filled-in');
        } else {
            $('#card-from').html($(this).val()).removeClass('filled-in');
        }
    });

    // Changing For
    objForm.find('input#txtReceiverName').change(function () {
        if ($(this).val()) {
            $('#card-to').html($(this).val()).addClass('filled-in');
        } else {
            $('#card-to').html($(this).val()).removeClass('filled-in');
        }
    });

    // Changing format
    objForm.find('input[name=\'optFormat\']').click(function () {
        if ($(this).val() == 'paper') {
            // Hide email fields and send method if you choose for paper
            objForm.find('div#step-send-method').addClass('d-none');
            objForm.find('input#txtEmail').addClass('d-none');
            objForm.find('input#txtEmail').removeClass('required customemail');
            objForm.find('input#txtReceiverEmail').removeClass('required customemail');
        } else {
            // Show email fields and send method if you choose for digital
            objForm.find('div#step-send-method').removeClass('d-none');
            objForm.find('input#txtEmail').removeClass('d-none');
            objForm.find('input#txtEmail').addClass('required customemail');
            objForm.find('input#txtReceiverEmail').addClass('required customemail');
        }
    });

    // Changing delivery method
    objForm.find('input[name=\'optSendReceiver\']').click(function () {
        if ($(this).val() == 'off') {
            // Hide email receiver if you choose to deliver it yourself
            objForm.find('#receiver-email').addClass('d-none');
            objForm.find('#receiver-email input.required').removeClass('required');
        } else {
            // Show email receiver if you choose to mail the giftcard directly to the receiver
            objForm.find('#receiver-email').removeClass('d-none');
            objForm.find('#receiver-email input').addClass('required');
        }
    });

    // Click on button 'In cart'
    $('form#frmAddToCart #btnAddToCart').click(function () {
        // First check of all gfitcard fields are filled in, then add to cart
        FormValidateGiftCard($('form#frmAddToCart'));
    });
    // Add to cart
    //AddToCart($("form#frmAddToCart button#btnAddToCart"), false, false);
});